import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import ProfissionalForm from '../../../components/profissional/forms';
import { VerticalContainer } from '../../../components/styled';
import { Creators as ProfissionalActions } from '../../../store/ducks/profissional';

export default function AddProfissional() {
  const [error, setError] = useState();
  const dispatch = useDispatch();
  const { loading, error: erro } = useSelector((state) => state.profissional);
  const onFinish = async (values) => {
    dispatch(ProfissionalActions.registerProfissionalRequest(values));
  };

  useEffect(() => {
    setError(erro);
  }, [erro]);

  return (
    <VerticalContainer>
      <div />
      <ProfissionalForm
        onFinish={onFinish}
        error={error}
        setError={setError}
        loading={loading}
      />
    </VerticalContainer>
  );
}
